import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { StrapiGatsbyImageType } from "./common";
import { OneTileDynamicZoneModel } from "./tile-wrapper";

export enum ThreePointImagePosition {
  RIGHT = "right",
  LEFT = "left",
}

export interface ThreePointsHighLighterDynamicZoneModel
  extends BaseDynamicZoneModel {
  bgColor: string;
  imgPostion: ThreePointImagePosition;
  threePointImage: StrapiGatsbyImageType;
  tiles: OneTileDynamicZoneModel[];
}
